import { useContext } from 'react';
import { ConfigContext } from './ConfigProvider';

export function usePaletteConfig() {
    const paletteConfig = useContext(ConfigContext);

    return paletteConfig;
}
